export default {
  "about": "О нас",
  "about_title": "О нас",
  "access_secret": "Секрет доступа",
  "access_token": "Токен доступа",
  "accessibility_animations": "Анимации",
  "accessibility_contrast": "Контраст",
  "accessibility_font_size": "Размер шрифта",
  "accessibility_title": "Доступность",
  "actions": "Действия",
  "active": "Активный",
  "active_ads": "Активные объявления",
  "active_campaigns": "Активные кампании",
  "ad_code_placeholder": "<script>...</script> или код слота AdSense",
  "ad_format": "Формат объявления",
  "ad_formats": "Форматы рекламы",
  "ad_management": "Управление рекламой",
  "ad_position_settings": "Настройки позиции объявлений",
  "ad_price_list": "Прайс-лист рекламы",
  "ad_pricing_formats_campaigns": "Цены, форматы, кампании и отслеживание",
  "add": "Добавить",
  "add_api_keys": "Добавьте ключи API на вкладке 'Настройки'",
  "address": "Адрес",
  "admin": "Админ",
  "adminPanel": "Панель администратора",
  "admin_ab_testing_title": "A/B тестирование",
  "admin_accent": "Акцент",
  "admin_accent_color": "Цвет акцента",
  "admin_action": "Действие",
  "admin_activate": "Активировать",
  "admin_active_feeds": "Активные ленты",
  "admin_active_label": "АКТИВНО",
  "admin_active_now": "Активно сейчас",
  "admin_active_subscribers": "Активные подписчики",
  "admin_ad_performance": "Эффективность объявлений",
  "admin_add_feed": "Добавить ленту",
  "admin_add_tag": "Добавить тег",
  "admin_admins": "Админы",
  "admin_advertisements": "Реклама",
  "admin_advertiser_email": "Электронная почта рекламодателя",
  "admin_advertiser_name": "Имя рекламодателя",
  "admin_affiliate_links": "Партнерские ссылки",
  "admin_ai_content_title": "Обработка контента ИИ",
  "admin_ai_prompt_settings": "Настройки подсказок и моделей ИИ",
  "admin_analytics_title": "Аналитика",
  "admin_api_latency": "Задержка API",
  "admin_api_server": "API сервер",
  "admin_article_actions": "Действия",
  "admin_article_category": "Категория",
  "admin_article_published": "Опубликовано",
  "admin_article_selector": "Селектор статьи (CSS, например, article.news)",
  "admin_article_views": "Просмотры",
  "admin_articles_count": "Статьи",
  "admin_articles_title": "Статьи",
  "admin_author_change_failed": "Не удалось изменить автора.",
  "admin_authors_title": "Авторы",
  "admin_auto": "АВТО",
  "admin_auto_save_draft": "Автосохранение в черновик",
  "admin_avg_seo_score": "Средний SEO балл",
  "admin_bio": "Биография",
  "admin_blog_manage": "Управление блог-постами с помощью редактора богатоого содержания",
  "admin_blog_title": "Блог",
  "admin_brand_theme": "Бренд и Тема",
  "admin_branding_desc": "Настройка внешнего вида сайта (только для системного администратора)",
  "admin_branding_title": "Модуль ребрендинга",
  "admin_breaking_ticker": "Лента срочных новостей",
  "admin_browser": "Браузер",
  "admin_browsers": "Браузеры",
  "admin_bug_reports": "Отчеты об ошибках",
  "admin_bulk_delete_failed": "Не удалось удалить несколько.",
  "admin_bulk_operations": "Массовые операции",
  "admin_categories_grid": "Сетка категорий",
  "admin_choose_gallery": "Выбрать из галереи",
  "admin_churn_prediction": "Прогноз оттока",
  "admin_classic_portal": "Классический новостной портал",
  "admin_classifieds": "Объявления",
  "admin_clear_log": "Очистить лог",
  "admin_click_button": "Нажмите кнопку",
  "admin_collection_stats": "Статистика коллекции",
  "admin_color_scheme": "Цветовая схема",
  "admin_columnist": "Колумнист",
  "admin_comments": "Комментарии",
  "admin_competitor_monitoring": "Мониторинг конкурентов",
  "admin_confirm_action": "Вы уверены?",
  "admin_content_calendar_title": "Календарь контента",
  "admin_content_filter": "Условия фильтра контента",
  "admin_content_stats": "Статистика контента",
  "admin_contributor": "Автор",
  "admin_coordinates": "Координаты",
  "admin_copy_ip": "Копировать IP-адрес",
  "admin_copy_text": "Копировать",
  "admin_core_services": "Основные сервисы",
  "admin_countries": "Страны",
  "admin_cpc": "CPC (EUR)",
  "admin_crawl_now": "Сканировать сейчас",
  "admin_create_author": "Создать автора",
  "admin_create_manage_promo": "Создание и управление промо-кодами",
  "admin_create_voucher": "Создать ваучер",
  "admin_custom_meta": "Пользовательские метаданные",
  "admin_dashboard_title": "Дашборд",
  "admin_database": "База данных",
  "admin_db_backup": "Резервное копирование базы данных",
  "admin_db_latency": "Задержка базы данных",
  "admin_db_name": "Название базы данных",
  "admin_db_size": "Размер базы данных",
  "admin_default": "ПО УМОЛЧАНИЮ",
  "admin_default_language": "Язык по умолчанию",
  "admin_device": "Устройство",
  "admin_devices": "Устройства",
  "admin_discount": "Скидка",
  "admin_disk_usage": "Использование диска",
  "admin_docs_api_ref": "Справочник API",
  "admin_docs_download_pdf": "Скачать PDF",
  "admin_docs_faq": "Часто задаваемые вопросы",
  "admin_docs_getting_started": "Начало работы",
  "admin_docs_implemented": "Реализовано",
  "admin_docs_no_pages": "Документация пока отсутствует",
  "admin_docs_order": "Порядок",
  "admin_docs_title": "Документация",
  "admin_doktor_earnings": "Заработок Doktor",
  "admin_draft_articles": "Черновики статей",
  "admin_dynamic_pricing": "Динамическое ценообразование",
  "admin_edit_in_cms": "Редактировать в CMS",
  "admin_editor_role": "Редактор",
  "admin_export_csv": "Экспорт CSV",
  "admin_favicon": "Иконка (Favicon)",
  "admin_feed_crawler": "Кроулер ленты",
  "admin_feed_name": "Название ленты",
  "admin_feed_url": "URL ленты",
  "admin_feeds_title": "RSS ленты",
  "admin_file": "Файл",
  "admin_fixed_amount": "Фиксированная сумма",
  "admin_frozen": "Заморожено",
  "admin_full_name": "Полное имя",
  "admin_general": "Общее",
  "admin_google_search_console": "Google Search Console",
  "admin_grade": "Оценка",
  "admin_health_title": "Проверка состояния",
  "admin_high_leads": "Ценные лиды",
  "admin_import_title": "Платформа импорта Croatia Times",
  "admin_index_now": "IndexNow",
  "admin_integrations": "Интеграции",
  "admin_job_postings": "Объявления о вакансиях",
  "admin_joined": "Присоединился",
  "admin_keywords": "Ключевые слова",
  "admin_landing_title": "Лендинг страницы",
  "admin_last_submissions": "Последние отправки",
  "admin_live_analytics": "Живая аналитика",
  "admin_live_analytics_title": "Живая аналитика",
  "admin_llm_model": "Модель LLM",
  "admin_manage_feeds": "Управление лентами",
  "admin_mass_management": "Массовое управление статьями",
  "admin_max_articles": "Макс. статей",
  "admin_media_storage": "Хранилище медиа",
  "admin_memory": "Память",
  "admin_menu_manager": "Менеджер меню",
  "admin_meta_description": "Метаописание",
  "admin_monetization_title": "Панель монетизации",
  "admin_mysql_db": "База данных MySQL",
  "admin_mysql_host": "Хост MySQL",
  "admin_nav_ab_testing": "A/B тестирование",
  "admin_nav_ads": "Управление рекламой",
  "admin_nav_ads_report": "Отчет по рекламе",
  "admin_nav_adsense": "Настройки AdSense",
  "admin_nav_advanced_analytics": "Расширенная аналитика",
  "admin_nav_affiliates": "Партнерские ссылки",
  "admin_nav_ai_content": "Обработка контента с AI",
  "admin_nav_amp": "AMP и Google Discover",
  "admin_nav_analytics": "Аналитика",
  "admin_nav_analytics_ai": "Аналитика и ИИ",
  "admin_nav_articles": "Статьи",
  "admin_nav_audit_log": "Аудит лог",
  "admin_nav_authors": "Авторы",
  "admin_nav_blog": "Блог",
  "admin_nav_branding": "Ребрендинг",
  "admin_nav_breaking_news": "Срочные / Экстренные новости",
  "admin_nav_bulk_operations": "Массовые операции",
  "admin_nav_categories": "Категории",
  "admin_nav_chat_sessions": "Чат-сессии",
  "admin_nav_churn_prediction": "Прогноз оттока",
  "admin_nav_classifieds": "Объявления",
  "admin_nav_comments": "Комментарии",
  "admin_nav_competitor_monitoring": "Мониторинг конкурентов",
  "admin_nav_content": "Контент",
  "admin_nav_content_calendar": "Календарь контента",
  "admin_nav_county_map": "Карта округа",
  "admin_nav_crypto": "Криптовиджет",
  "admin_nav_dashboard": "Панель управления",
  "admin_nav_db_backup": "База данных",
  "admin_nav_docs": "Документация",
  "admin_nav_doktor_earnings": "Заработок Doktor",
  "admin_nav_duplicate_detection": "Обнаружение дубликатов",
  "admin_nav_editorial": "Редакция",
  "admin_nav_editorial_workflow": "Редакционный процесс",
  "admin_nav_email_campaigns": "Email-кампании",
  "admin_nav_feeds": "RSS-ленты",
  "admin_nav_finance": "Финансы",
  "admin_nav_health": "Системное состояние",
  "admin_nav_heatmaps": "Карта тепла чтения",
  "admin_nav_import": "Импорт",
  "admin_nav_invoices": "Счета",
  "admin_nav_job_ads": "Объявления о работе",
  "admin_nav_landing_pages": "Целевые страницы",
  "admin_nav_live_analytics": "Аналитика в реальном времени",
  "admin_nav_management": "Управление",
  "admin_nav_marketing": "Маркетинг",
  "admin_nav_media": "Медиа",
  "admin_nav_menu_manager": "Менеджер меню",
  "admin_nav_micropayments": "Микроплатежи",
  "admin_nav_monetization": "Монетизация",
  "admin_nav_newsletter": "Новостная рассылка",
  "admin_nav_newsletter_digest": "Дайджест новостей",
  "admin_nav_pages": "Страницы",
  "admin_nav_payments": "Платежи",
  "admin_nav_performance_forecast": "Прогноз производительности",
  "admin_nav_photo_verification": "Фото проверка",
  "admin_nav_portal_toggle": "Управление порталом",
  "admin_nav_portals": "Порталы",
  "admin_nav_pricing": "Ценообразование",
  "admin_nav_promo_codes": "Промо-коды",
  "admin_nav_push_notifications": "Push-уведомления",
  "admin_nav_quizzes": "Викторины",
  "admin_nav_recommendations": "Рекомендации контента",
  "admin_nav_reports": "Отчеты по контенту",
  "admin_nav_sanitization": "Очистка контента",
  "admin_nav_scheduler": "Планировщик контента",
  "admin_nav_security": "Безопасность",
  "admin_nav_seo_dashboard": "Панель управления SEO",
  "admin_nav_seo_distribution": "SEO и распространение",
  "admin_nav_series": "Серия статей",
  "admin_nav_settings": "Настройки",
  "admin_nav_social": "Социальные сети",
  "admin_nav_social_scheduler": "Планировщик социальных сетей",
  "admin_nav_sponsored": "Спонсированные",
  "admin_nav_sponsored_marketplace": "Спонсируемый рынок",
  "admin_nav_subscriptions": "Подписки",
  "admin_nav_surveys": "Опросы",
  "admin_nav_syndication": "API синдикации",
  "admin_nav_system": "Система",
  "admin_nav_tips": "Чаевые / Пожертвования",
  "admin_nav_translations": "Переводы",
  "admin_nav_ugc_review": "Контент от граждан",
  "admin_nav_users": "Пользователи",
  "admin_nav_users_subscriptions": "Пользователи и подписки",
  "admin_nav_versioning": "История версий",
  "admin_nav_vibeposao": "Times Posao Portal",
  "admin_nav_vouchers": "Ваучеры / Скидки",
  "admin_nav_widgets": "Виджеты / Каталоги",
  "admin_new_author_name": "Новое имя автора...",
  "admin_new_post": "Новый пост",
  "admin_no_data": "Нет доступных данных",
  "admin_no_icon": "Без иконки",
  "admin_no_logo": "Без логотипа",
  "admin_no_pending_reports": "Нет ожидающих отчетов",
  "admin_no_published_articles": "Опубликованных статей не найдено",
  "admin_password_field": "Пароль",
  "admin_performance_forecast": "Прогноз производительности",
  "admin_photo_verification": "Проверка фотографий",
  "admin_plan": "План",
  "admin_platform_audit": "Аудит платформы",
  "admin_portal_toggle": "Управление порталом",
  "admin_premium_users": "Премиум пользователи",
  "admin_primary": "Основной",
  "admin_published_articles": "Опубликованные статьи",
  "admin_published_today": "Опубликовано сегодня",
  "admin_quick_actions": "Быстрые действия",
  "admin_recent_articles": "Недавние статьи",
  "admin_role_change_failed": "Не удалось обновить роль.",
  "admin_search_placeholder": "Поиск по админке...",
  "admin_secondary": "Вторичный",
  "admin_seo_desc": "Оптимизация контента, управление GSC и картами сайта",
  "admin_seo_title": "Панель SEO",
  "admin_service_requests": "Запросы на обслуживание",
  "admin_set_category": "Установить категорию",
  "admin_set_featured": "Отметить как избранное",
  "admin_settings_saved": "Настройки сохранены",
  "admin_settings_title": "Настройки",
  "admin_short_desc": "Краткое описание",
  "admin_site_identity": "Идентичность сайта",
  "admin_site_logo": "Логотип сайта",
  "admin_site_settings": "Настройки сайта",
  "admin_sponsored_marketplace": "Спонсируемый рынок",
  "admin_sponsored_title": "Спонсорские статьи",
  "admin_surveys_title": "Опросы",
  "admin_system_status": "Состояние системы",
  "admin_table_header_actions": "Действия",
  "admin_table_header_date": "Дата",
  "admin_table_header_email": "Электронная почта",
  "admin_table_header_name": "Имя",
  "admin_table_header_status": "Статус",
  "admin_thumbnail_settings_saved": "Настройки миниатюр сохранены",
  "admin_top_articles_views": "Топ статей по просмотрам",
  "admin_total_articles": "Всего статей",
  "admin_total_users": "Всего пользователей",
  "admin_total_views": "Всего просмотров",
  "admin_ugc_review": "Проверка UGC",
  "admin_username": "Имя пользователя",
  "admin_users_title": "Пользователи",
  "admin_version_history": "История версий",
  "admin_view_health_report": "Просмотреть полный отчет о состоянии",
  "admin_write_new_article": "Написать новую статью",
  "adsense_client_id": "Идентификатор клиента AdSense",
  "adsense_enable_disable": "Включить/отключить всё автоматизированное размещение объявлений",
  "adsense_global_toggle": "Глобальный переключатель AdSense",
  "adsense_script_code": "Код скрипта AdSense",
  "adsense_settings": "Настройки AdSense и позиции объявлений",
  "advertise_contact_sales": "Свяжитесь с отделом продаж",
  "advertise_get_started": "Начать",
  "advertise_reach_audience": "Охватите нашу аудиторию",
  "advertise_title": "Рекламируйте у нас",
  "advertiser": "Рекламодатель",
  "advertiser_analytics": "Аналитика рекламодателя",
  "advertiser_email": "Электронная почта рекламодателя",
  "advertising": "Реклама",
  "advertising_cookies": "Рекламные cookies",
  "affiliate_title": "Партнерская программа",
  "ago": "назад",
  "ai_image_prompt": "Подсказка для изображения AI",
  "all": "Все",
  "all_categories": "Все категории",
  "all_jobs": "Все вакансии",
  "all_rights": "Все права защищены",
  "all_status": "Все статусы",
  "all_types": "Все типы",
  "alpha": "Альфа",
  "alreadyHaveAccount": "Уже есть аккаунт?",
  "already_have_account": "Уже есть аккаунт?",
  "analytics": "Аналитика",
  "analytics_cookies": "Аналитические cookies",
  "api_key": "Ключ API",
  "api_secret": "Секрет API",
  "applications": "Заявки",
  "apply": "Применить",
  "apply_now": "Подать заявку",
  "approve": "Одобрить",
  "approved": "Одобрено",
  "archive": "Архивировать",
  "archived": "Архивировано",
  "article_content": "Содержание статьи",
  "article_title": "Заголовок статьи...",
  "article_views": "Просмотры",
  "author": "Автор",
  "auto_posting": "Автоматическая публикация и социальные интеграции",
  "auto_share_articles": "Автоматически делиться опубликованными статьями на подключенных платформах",
  "avg_ctr": "Средний CTR",
  "back": "Назад",
  "basic": "Базовый",
  "be_respectful": "Будьте вежливы и уважительны к другим пользователям и персонам статей",
  "beta": "Бета",
  "book_ad": "Заказать рекламу",
  "booking_details": "Детали бронирования",
  "breaking": "СРОЧНО",
  "bug_description": "Описание ошибки",
  "business": "Бизнес",
  "business_account_id": "ID бизнес-аккаунта",
  "buyer": "Покупатель",
  "campaign_details": "Детали кампании",
  "campaigns": "Кампании",
  "cancel": "Отмена",
  "caption": "Подпись",
  "categories": "Категории",
  "category": "Категория",
  "category_distribution": "Распределение категорий",
  "category_push_subscribers": "Подписчики категории на Push",
  "chatbot_placeholder": "Введите сообщение...",
  "chatbot_send": "Отправить",
  "chatbot_title": "Чат-ассистент",
  "choose_plan": "Выберите план",
  "city": "Город",
  "classifieds": "Объявления",
  "classifieds_title": "Объявления",
  "clear": "Очистить",
  "click_rate": "Процент кликов",
  "click_url": "URL для клика (назначение)",
  "clicks": "Клики",
  "client_id": "ID клиента",
  "client_secret": "Секрет клиента",
  "close": "Закрыть",
  "code": "Код",
  "commenting_rules": "Правила комментирования",
  "comments": "Комментарии",
  "companies": "Компании",
  "company": "Компания",
  "compose_social_post": "Создать публикацию для социальных сетей",
  "configure": "Настроить",
  "configure_position": "Настройте каждую позицию с пользовательским изображением баннера или кодом объявления",
  "confirm": "Подтвердить",
  "confirm_delete": "Вы уверены, что хотите удалить?",
  "confirm_password": "Подтвердите пароль",
  "congratulations": "Поздравляем",
  "contact": "Контакты",
  "contact_title": "Контакт",
  "contact_us": "Связаться с нами",
  "content": "Контент",
  "cookies": "Cookies",
  "cookies_title": "Политика использования cookies",
  "copy": "Копировать",
  "copyright": "Авторское право",
  "copyright_notice": "Авторские права",
  "count": "Количество",
  "country": "Страна",
  "cpm": "CPM",
  "create": "Создать",
  "create_first_ad": "Создайте своё первое объявление",
  "crypto_change_24h": "Изменение за 24ч",
  "crypto_market_cap": "Рыночная капитализация",
  "crypto_price": "Цена",
  "crypto_widget_title": "Крипто",
  "ctr": "CTR",
  "culture": "Культура",
  "current_plan": "Текущий план",
  "custom_ad_code": "Пользовательский код объявления",
  "custom_banner_url": "URL пользовательского баннера",
  "custom_range": "Произвольный диапазон",
  "daily_budget": "Ежедневный бюджет",
  "daily_performance": "Ежедневная производительность",
  "dark_mode": "Темная тема",
  "data_viz_title": "Визуализация данных",
  "date": "Дата",
  "dating_add_video": "Добавьте короткое видео, чтобы потенциальные совпадения могли лучше вас узнать",
  "dating_block": "Блокировать",
  "dating_boosts": "Ускорения",
  "dating_city": "Город",
  "dating_next": "Далее",
  "dating_personality_quiz": "Тест на личность",
  "dating_quiz_completed": "Тест на личность завершен",
  "dating_users": "Пользователи",
  "dating_verify_identity": "Подтвердите, что вы реальный человек",
  "dating_voice_message": "Голосовое сообщение",
  "days": "дней",
  "delete": "Удалить",
  "delete_failed": "Не удалось удалить.",
  "deleted_successfully": "Успешно удалено",
  "deprecated": "Устарело",
  "describe_thumbnail": "Опишите изображение миниатюры для генерации...",
  "description": "Описание",
  "deselect_all": "Снять выделение со всех",
  "desktop": "Настольный компьютер",
  "details": "Детали",
  "dimensions": "Размеры",
  "disabled": "Выключено",
  "dismiss": "Отклонить",
  "documentation": "Документация",
  "doktor_add_document": "Добавить документ",
  "doktor_biography": "Биография",
  "doktor_birth_date": "Дата рождения",
  "doktor_chat": "Чат",
  "doktor_control_date": "Дата контроля",
  "doktor_date": "Дата",
  "doktor_diagnosis": "Диагноз",
  "doktor_enter_name_specialization": "Введите имя и хотя бы одну специализацию",
  "doktor_enter_patient_name": "Введите имя пациента",
  "doktor_license_number": "Номер лицензии",
  "doktor_panel": "Панель доктора",
  "doktor_patient_name": "Имя пациента",
  "doktor_text_min_chars": "Текст должен содержать не менее 50 символов",
  "doktor_waiting_room": "Комната ожидания",
  "dont_have_account": "Нет аккаунта?",
  "download": "Скачать",
  "draft": "Черновик",
  "duplicate": "Дублировать",
  "duration_days": "Продолжительность (дни)",
  "economy": "Экономика",
  "edit": "Редактировать",
  "electronics": "Электроника",
  "email": "Электронная почта",
  "email_address": "Адрес электронной почты",
  "email_campaigns": "Email кампании",
  "email_clicks": "Клики по электронным письмам",
  "email_content": "Содержимое письма...",
  "email_opens": "Открытия электронных писем",
  "email_placeholder": "Ваш email",
  "email_subject": "Тема письма",
  "employer": "Работодатель",
  "enabled": "Включено",
  "end_date": "Дата окончания",
  "enter_advertiser_email": "Введите вашу электронную почту рекламодателя...",
  "enter_email_to_view": "Введите вашу электронную почту рекламодателя выше, чтобы просмотреть производительность вашей кампании",
  "entertainment": "Развлечения",
  "error": "Ошибка",
  "error_deleting": "Ошибка при удалении",
  "error_generating_digest": "Ошибка при создании дайджеста",
  "error_loading": "Ошибка при загрузке",
  "error_saving": "Ошибка при сохранении",
  "error_saving_settings": "Ошибка сохранения",
  "error_sending": "Ошибка отправки",
  "error_uploading": "Ошибка при загрузке",
  "error_uploading_photo": "Не удалось загрузить фото",
  "events_calendar": "Календарь событий",
  "excerpt_summary": "Выдержка / Резюме",
  "experimental": "Экспериментальный",
  "export": "Экспорт",
  "export_data": "Экспорт данных",
  "facebook": "Facebook",
  "facebook_login_unavailable": "Вход через Facebook недоступен",
  "failed_post_comment": "Не удалось оставить комментарий.",
  "feature_flags": "Флаги функций",
  "feature_job": "Рекомендуемая вакансия",
  "featured": "Рекомендуемое",
  "featured_article": "Рекомендуемая статья",
  "featured_duration": "Рекомендуемая продолжительность",
  "featured_image": "Рекомендуемое изображение",
  "featured_jobs": "Рекомендуемые вакансии",
  "feedback": "Обратная связь",
  "filter": "Фильтр",
  "filter_terms_saved": "Условия фильтра сохранены!",
  "find_jobs": "Найти работу",
  "first": "Первая",
  "first_process_publish": "Сначала обработайте и опубликуйте статью",
  "footer_ai": "Портал использует ИИ",
  "footer_ai_notice": "Некоторый контент создан с помощью AI — сообщите о проблемах",
  "footer_cat_business": "Бизнес",
  "footer_cat_culture": "Культура",
  "footer_cat_health": "Здоровье",
  "footer_cat_news": "Новости",
  "footer_cat_politics": "Политика",
  "footer_cat_sports": "Спорт",
  "footer_cat_technology": "Технологии",
  "footer_categories": "Категории",
  "footer_copyright": "2026 Liber Nostra d.o.o. Все права защищены.",
  "footer_description": "Croatia Times — ваш надежный источник экстренных новостей, глубокого анализа и увлекательных историй из Хорватии и за ее пределами.",
  "footer_developed_by": "Разработано и поддерживается с любовью",
  "footer_email_placeholder": "Ваш адрес электронной почты",
  "footer_here": "здесь",
  "footer_hosted_by": "Хостинг предоставлен",
  "footer_link_about": "О нас",
  "footer_link_advertise": "Реклама",
  "footer_link_contact": "Контакты",
  "footer_link_cookies": "Файлы cookie",
  "footer_link_imprint": "Выходные данные",
  "footer_link_privacy": "Политика конфиденциальности",
  "footer_link_submit_news": "Отправить новости",
  "footer_newsletter_text": "Подпишитесь на нашу новостную рассылку",
  "footer_quick_links": "Быстрые ссылки",
  "footer_stay_informed": "Будьте в курсе",
  "footer_subscribe": "Подписаться",
  "for_you_personalized": "Персонализированный контент на основе ваших интересов",
  "for_you_title": "Для вас",
  "forgot_password": "Забыли пароль?",
  "free": "Бесплатно",
  "free_plan": "Бесплатно",
  "from": "От",
  "full_time": "Полный рабочий день",
  "general": "Общие",
  "goodbye": "До свидания",
  "hashtags": "Хэштеги",
  "hashtags_placeholder": "#новости #croatia...",
  "header_auto_schedule_active": "Авторасписание активно",
  "header_forecast": "Прогноз",
  "header_humidity": "Влажность",
  "header_live": "ПРЯМОЙ ЭФИР",
  "header_portals_label": "Порталы",
  "header_weather_humidity": "Влажность",
  "header_weather_wind": "Ветер",
  "header_wind": "Ветер",
  "health": "Здоровье",
  "hello": "Здравствуйте",
  "help": "Помощь",
  "home": "Главная",
  "home_podcast_title": "Еженедельный обзор технологий: ИИ в хорватских стартапах",
  "home_video_title": "Внутри Загреба: Документальный фильм о стрит-арте",
  "hours": "часов",
  "import": "Импорт",
  "impressions": "Показы",
  "imprint": "Импрессум",
  "imprint_title": "Импрессум",
  "inactive": "Неактивный",
  "info": "Информация",
  "instagram": "Instagram",
  "invalid_code": "Неверный код. Попробуйте снова.",
  "items_selected": "элементов выбрано",
  "job_categories": "Категории вакансий",
  "job_postings": "Объявления о работе",
  "job_seeker": "Соискатель",
  "jobs": "Вакансии",
  "just_now": "Только что",
  "language": "Язык",
  "last": "Последняя",
  "latest_news": "Последние новости",
  "legal": "Юридическая информация",
  "lifestyle": "Стиль жизни",
  "lifetime": "Пожизненный",
  "light_mode": "Светлая тема",
  "linked_email_campaign": "Связано с email-кампанией",
  "linkedin": "LinkedIn",
  "live_stream": "Прямой эфир",
  "load_more": "Загрузить ещё",
  "loading": "Загрузка...",
  "local": "Местные",
  "location": "Местоположение",
  "login": "Войти",
  "logout": "Выйти",
  "loyalty_available_points": "Доступные баллы",
  "loyalty_available_rewards": "Доступные награды",
  "loyalty_badges": "Значки",
  "loyalty_consecutive_days": "Последовательные дни",
  "loyalty_error": "Ошибка",
  "loyalty_leaderboard": "Таблица лидеров",
  "loyalty_leaderboard_empty": "Таблица лидеров пуста",
  "loyalty_rewards": "Награды",
  "loyalty_used_rewards": "Использованные награды",
  "majstor_categories": "Категории",
  "majstor_city": "Город",
  "majstor_company_name": "Название компании *",
  "majstor_flexible": "Гибкий",
  "majstor_max_budget": "Максимальный бюджет (EUR)",
  "majstor_min_budget": "Минимальный бюджет (EUR)",
  "majstor_my_requests": "Мои запросы",
  "majstor_request_title": "Заголовок запроса *",
  "majstor_service_categories": "Категории услуг",
  "majstor_urgent": "Срочно",
  "manage": "Управлять",
  "manage_bookings": "Управление бронированием рекламодателя",
  "mark_as_read": "Отметить как прочитанное",
  "marketing_dashboard": "Маркетинговая панель",
  "marketing_live_metrics": "Показатели работы в реальном времени для Croatia Times",
  "marketing_published_articles": "Опубликованные статьи",
  "marketing_registered_users": "Зарегистрированные пользователи",
  "marketing_today_views": "Сегодняшние просмотры",
  "marketing_total_views": "Общее количество просмотров страниц",
  "minutes": "минут",
  "missing_translations": "Отсутствующие переводы",
  "mobile": "Мобильный",
  "more": "Еще",
  "most_popular": "Самый популярный",
  "most_read": "Самое читаемое",
  "move": "Переместить",
  "must_be_logged_in_purchase": "Вы должны войти в систему, чтобы купить статью",
  "myProfile": "Мой профиль",
  "my_applications": "Мои заявки",
  "name": "Имя",
  "new": "Новое",
  "new_article": "Новая статья",
  "new_campaign": "Новая кампания",
  "new_notification": "Новое уведомление",
  "new_push_notification": "Новое Push-уведомление",
  "new_verification_sent": "Новый код подтверждения отправлен на вашу электронную почту.",
  "news": "Новости",
  "newsletter": "Рассылка",
  "newsletter_desc": "Подпишитесь на последние новости",
  "newsletter_only_subscribers": "Только подписчики",
  "newsletter_subscribers": "Подписчики на новостную рассылку",
  "next": "Далее",
  "no": "Нет",
  "noAccount": "Нет аккаунта?",
  "no_articles": "Статей не найдено",
  "no_bookings": "Бронирования не найдены",
  "no_campaigns": "Нет кампаний",
  "no_data": "Нет доступных данных",
  "no_items": "Элементы не найдены",
  "no_linked_campaign": "Нет связанной кампании",
  "no_notifications": "Нет уведомлений",
  "no_results": "Нет результатов",
  "no_scheduled_posts": "Нет запланированных публикаций",
  "no_sent_notifications": "Нет отправленных уведомлений",
  "none": "Нет",
  "note": "Примечание",
  "notification_body": "Тело уведомления",
  "notification_title": "Заголовок уведомления",
  "notifications": "Уведомления",
  "of": "из",
  "off": "Выключено",
  "offline": "Оффлайн",
  "on": "Включено",
  "one_time": "разово",
  "online": "Онлайн",
  "open_rate": "Процент открытий",
  "optional": "Необязательно",
  "options": "Опции",
  "orContinueWith": "Или продолжить с",
  "or_continue_with": "Или продолжить с",
  "order": "Заказ",
  "other": "Прочее",
  "page": "Страница",
  "part_time": "Неполный рабочий день",
  "password": "Пароль",
  "paste": "Вставить",
  "pause": "Пауза",
  "payment_error": "Ошибка оплаты",
  "payment_processing": "Обработка платежа...",
  "payment_success": "Оплата успешна!",
  "payment_thank_you": "Спасибо за вашу покупку!",
  "pending": "В ожидании",
  "pending_approval": "Ожидает утверждения",
  "per_month": "/мес",
  "per_page": "на страницу",
  "percentage": "Процент",
  "performance": "Производительность",
  "phone": "Телефон",
  "platforms": "Платформы",
  "politics": "Политика",
  "poll_results": "Результаты",
  "poll_total_votes": "Всего голосов",
  "poll_vote": "Голосовать",
  "popular": "Популярное",
  "post_comment": "Оставить комментарий",
  "post_error": "Ошибка публикации",
  "post_job": "Разместить вакансию",
  "post_now": "Опубликовать сейчас",
  "powered_by": "Разработано с помощью",
  "premium": "Премиум",
  "preview": "Предварительный просмотр",
  "previous": "Назад",
  "price": "Цена",
  "privacy": "Конфиденциальность",
  "privacy_title": "Политика конфиденциальности",
  "proceed_to_payment": "Перейти к оплате",
  "profile": "Профиль",
  "profile_admin_access": "Быстрый доступ администратора",
  "profile_analytics": "Аналитика",
  "profile_articles": "Статьи",
  "profile_dashboard": "Панель управления",
  "profile_edit": "Редактировать профиль",
  "profile_verified": "Профиль подтвержден!",
  "promo_success": "Промокод успешно применен!",
  "promote_job": "Продвигать вакансию",
  "publish": "Опубликовать",
  "published": "Опубликовано",
  "published_date": "Опубликовано",
  "push_notifications": "Push-уведомления",
  "read": "Прочитано",
  "read_more": "Читать далее",
  "real_estate": "Недвижимость",
  "recent": "Недавние",
  "recipes_add_first": "Добавьте свой первый рецепт",
  "recipes_browse_all": "Просмотреть все рецепты",
  "recipes_category": "Категория",
  "recipes_cook_time": "Время приготовления",
  "recipes_easy": "Легко",
  "recipes_featured": "Избранные рецепты",
  "recipes_filters": "Фильтры",
  "recipes_ingredient": "Ингредиент",
  "recipes_ingredients": "Ингредиенты",
  "recipes_instructions": "Инструкции",
  "recipes_latest": "Последние рецепты",
  "recipes_most_popular": "Самые популярные рецепты",
  "recipes_prep_time": "Время подготовки",
  "recipes_search": "Поиск рецептов...",
  "recipes_servings": "Порции",
  "recipes_title": "Рецепты",
  "recommended": "Рекомендуется",
  "refresh": "Обновить",
  "region": "Регион",
  "register": "Регистрация",
  "reject": "Отклонить",
  "rejected": "Отклонено",
  "related_articles": "Похожие статьи",
  "remote": "Удаленно",
  "remove": "Удалить",
  "report": "Отчет",
  "reports": "Отчеты",
  "reposting_rules_title": "Правила перепоста",
  "required": "Обязательно",
  "reset": "Сбросить",
  "restore": "Восстановить",
  "results": "Результаты",
  "resume": "Возобновить",
  "revision_restored": "Версия восстановлена!",
  "salary": "Зарплата",
  "salary_max": "Максимальная зарплата",
  "salary_min": "Минимальная зарплата",
  "save": "Сохранить",
  "saved_jobs": "Сохраненные вакансии",
  "saved_successfully": "Успешно сохранено",
  "schedule": "Расписание",
  "scheduled": "Запланировано",
  "science": "Наука",
  "search": "Поиск...",
  "search_articles": "Поиск статей...",
  "search_placeholder": "Поиск...",
  "search_results_for": "Результаты поиска для",
  "seconds": "секунд",
  "see_all": "Показать все",
  "select": "Выбрать",
  "select_all": "Выбрать все",
  "select_format": "Выберите формат",
  "seller": "Продавец",
  "send_campaign": "Отправить кампанию",
  "sent": "Отправлено",
  "sent_campaigns": "Отправленные кампании",
  "services": "Услуги",
  "settings": "Настройки",
  "share": "Поделиться",
  "showing": "Показано",
  "signIn": "Войти",
  "signOut": "Выйти",
  "site_name": "Croatia Times",
  "site_subtitle": "Хорватия Сегодня",
  "six_digit_code": "6-значный код",
  "social_media": "Социальные сети",
  "social_scheduler": "Планировщик публикаций",
  "sort": "Сортировать",
  "sponsored_marketplace_title": "Спонсируемый рынок",
  "sports": "Спорт",
  "stable": "Стабильный",
  "start": "Начать",
  "start_date": "Дата начала",
  "static_about_contact": "Для редакционных запросов, рекламы или общей информации посетите нашу",
  "static_about_contact_page": "страницу контактов",
  "static_about_contact_title": "Контакты",
  "static_about_lead": "Croatia Times - это независимый новостной портал, предоставляющий вам последние новости, анализы, комментарии и истории из Хорватии и региона. Мы являемся частью медиа-семьи e-mina.eu с той же командой и теми же ценностями.",
  "static_about_mission": "Мы стремимся к предоставлению точной, своевременной и качественной журналистики, служащей общественным интересам. Наша редакционная команда состоит из опытных журналистов с глубокими знаниями о хорватских и региональных делах.",
  "static_about_mission_title": "Наша миссия",
  "static_about_publisher": "Liber Nostra d.o.o. является издателем Croatia Times и e-mina.eu. Компания специализируется на цифровых СМИ и новостных порталах, ориентированных на хорватский рынок.",
  "static_about_publisher_title": "Издатель",
  "static_about_standards": "Croatia Times придерживается высочайших журналистских стандартов. Мы проверяем факты в наших материалах, четко маркируем комментарии и анализы, а также оперативно и прозрачно исправляем ошибки.",
  "static_about_standards_title": "Редакционные стандарты",
  "static_about_team": "За Croatia Times стоит команда опытных медиа-профессионалов, журналистов, редакторов и технических специалистов, работающих над развитием платформы и качеством контента. Наша команда - это та же команда, стоящая за успешным порталом e-mina.eu - International News Agency.",
  "static_about_team_title": "Команда",
  "static_about_title": "О нас - Croatia Times",
  "static_bug_description": "Описание ошибки",
  "static_bug_description_placeholder": "Опишите, что произошло, и как воспроизвести проблему...",
  "static_bug_intro": "Нашли что-то, что работает неправильно? Дайте нам знать, и мы исправим это быстро.",
  "static_bug_page_url": "URL страницы (где произошла ошибка)",
  "static_bug_screenshot": "Скриншот (необязательно)",
  "static_bug_submit": "Отправить отчет об ошибке",
  "static_bug_submitting": "Отправка...",
  "static_bug_thanks": "Спасибо за ваш отчет! Мы исследуем и устраним проблему.",
  "static_bug_title": "Сообщить об ошибке",
  "static_commenting_intro": "Мы приветствуем конструктивное обсуждение. Чтобы наша секция комментариев оставалась позитивной и продуктивной, пожалуйста, соблюдайте эти правила:",
  "static_commenting_login": "Чтобы комментировать, вы должны быть зарегистрированы и войти в систему на Croatia Times.",
  "static_commenting_rule_1": "Будьте уважительны и вежливы к другим пользователям и объектам статей",
  "static_commenting_rule_2": "Запрещены оскорбления, расизм, сексизм или любая дискриминация",
  "static_commenting_rule_3": "Запрещены спам, реклама или промо-контент",
  "static_commenting_rule_4": "Запрещены дезинформация или распространение непроверенных утверждений",
  "static_commenting_rule_5": "Запрещены личные нападки или преследования",
  "static_commenting_rule_6": "Держитесь темы и вносите вклад в разговор",
  "static_commenting_rule_7": "Не размещайте личную или конфиденциальную информацию о третьих лицах",
  "static_commenting_title": "Правила комментирования",
  "static_commenting_violation": "Комментарии, нарушающие эти правила, могут быть удалены без предупреждения. Нарушители могут быть навсегда забанены.",
  "static_contact_email": "Электронная почта",
  "static_contact_message": "Сообщение",
  "static_contact_message_placeholder": "Ваше сообщение...",
  "static_contact_name": "Имя",
  "static_contact_name_placeholder": "Ваше имя",
  "static_contact_send": "Отправить сообщение",
  "static_contact_sending": "Отправка...",
  "static_contact_sent_desc": "Мы свяжемся с вами в течение 24 часов.",
  "static_contact_sent_title": "Сообщение отправлено!",
  "static_contact_subject": "Тема",
  "static_contact_subject_placeholder": "Как мы можем помочь?",
  "static_contact_title": "Свяжитесь с нами",
  "static_cookies_advertising_text": "Мы можем использовать файлы cookie Google AdSense для показа релевантной рекламы.",
  "static_cookies_advertising_title": "Рекламные файлы cookie",
  "static_cookies_analytics_text": "Google Analytics помогает нам понять, как посетители используют наш сайт. Данные по возможности анонимизированы.",
  "static_cookies_analytics_title": "Аналитические файлы cookie",
  "static_cookies_managing_text": "Вы можете управлять файлами cookie через настройки вашего браузера. Отключение необходимых файлов cookie может повлиять на функциональность сайта.",
  "static_cookies_managing_title": "Управление файлами cookie",
  "static_cookies_necessary_text": "Они необходимы для работы сайта (сессии входа, предпочтения темы). Они не могут быть отключены.",
  "static_cookies_necessary_title": "Необходимые файлы cookie",
  "static_cookies_title": "Политика использования файлов cookie",
  "static_cookies_types_title": "Типы используемых нами файлов cookie",
  "static_cookies_what_text": "Файлы cookie — это маленькие текстовые файлы, помещаемые на ваше устройство при посещении веб-сайта. Они помогают сайту запомнить ваши предпочтения и понять, как вы его используете.",
  "static_cookies_what_title": "Что такое файлы cookie",
  "static_imprint_ads_email": "Электронная почта (реклама):",
  "static_imprint_ai_notice": "Некоторые материалы созданы с использованием AI-технологии. Сообщайте об ошибках или неподобающем контенте на",
  "static_imprint_contact": "Контакты",
  "static_imprint_copyright": "Авторское право",
  "static_imprint_copyright_text": "Все материалы, опубликованные на Croatia Times, защищены авторским правом. Liber Nostra d.o.o. сохраняет все права на текстовые, графические и мультимедийные материалы, опубликованные на этом сайте. Подробная информация о правилах перепубликации материалов доступна на",
  "static_imprint_ct_desc": "новостной портал Croatia Times",
  "static_imprint_disclaimer": "Отказ от ответственности",
  "static_imprint_disclaimer_text": "Несмотря на тщательный контроль содержания, мы не несем ответственности за внешние ссылки. За их содержание несут ответственность исключительно их операторы.",
  "static_imprint_editorial_email": "Электронная почта (редакция):",
  "static_imprint_emina_desc": "International News Agency",
  "static_imprint_general_email": "Электронная почта (общие вопросы):",
  "static_imprint_last_updated": "Последнее обновление: февраль 2026 года",
  "static_imprint_or_via": "или через наш",
  "static_imprint_publisher": "Издатель",
  "static_imprint_registered": "Зарегистрировано в Республике Хорватия",
  "static_imprint_reposting_page": "странице правил перепубликации",
  "static_imprint_responsible": "Ответственные за содержание",
  "static_imprint_responsible_text": "Редакционная команда Croatia Times / Liber Nostra d.o.o.",
  "static_imprint_title": "Отпечаток",
  "static_imprint_websites": "Вебсайты",
  "static_privacy_controller": "Контролер данных: Liber Nostra d.o.o.",
  "static_privacy_cookies_text": "Мы используем файлы cookie для функциональности и аналитики. Подробности смотрите в нашей Политике использования файлов cookie.",
  "static_privacy_cookies_title": "Файлы cookie",
  "static_privacy_data_text": "Мы собираем данные, которые вы предоставляете напрямую (имя, электронная почта при регистрации), данные об использовании (посещенные страницы, прочитанные статьи) и технические данные (IP-адрес, тип браузера).",
  "static_privacy_data_title": "Данные, которые мы собираем",
  "static_privacy_last_updated": "Последнее обновление: январь 2026",
  "static_privacy_lead": "Croatia Times уважает вашу конфиденциальность и обязуется защищать ваши личные данные.",
  "static_privacy_retention_text": "Мы храним ваши данные до тех пор, пока ваш аккаунт активен или насколько это необходимо для юридических целей.",
  "static_privacy_retention_title": "Хранение данных",
  "static_privacy_rights_text": "Вы имеете право на доступ, исправление или удаление своих персональных данных. Свяжитесь с нами по",
  "static_privacy_rights_title": "Ваши права",
  "static_privacy_title": "Политика конфиденциальности",
  "static_privacy_usage_text": "Мы используем ваши данные для предоставления нашего новостного сервиса, персонализации вашего опыта, отправки новостных рассылок (с вашего согласия) и улучшения нашей платформы.",
  "static_privacy_usage_title": "Как мы используем ваши данные",
  "static_reposting_copyright_text": "Весь контент, опубликованный на Croatia Times, защищен авторским правом. Liber Nostra d.o.o. сохраняет все права на текст, изображения и мультимедиа, опубликованные на этом сайте.",
  "static_reposting_copyright_title": "Авторское право",
  "static_reposting_permission_text": "Для получения разрешения на перепечатку контента свяжитесь с нами по",
  "static_reposting_permission_title": "Запросы на разрешение",
  "static_reposting_permitted_text": "Вы можете размещать ссылки на наши статьи в социальных сетях и на других платформах. Краткие цитаты (до 2-х абзацев) могут использоваться с явным указанием авторства и ссылкой на оригинальную статью.",
  "static_reposting_permitted_title": "Разрешенное использование",
  "static_reposting_prohibited_text": "Полное воспроизведение статей без письменного разрешения запрещено. Изображения не могут быть воспроизведены без разрешения. Автоматизированное сканирование контента строго запрещено.",
  "static_reposting_prohibited_title": "Запрещенное использование",
  "static_reposting_title": "Правила перепечатки",
  "static_submit_news_details": "Детали истории",
  "static_submit_news_details_placeholder": "Опишите новость...",
  "static_submit_news_file_limit_error": "Файл превосходит лимит, равный",
  "static_submit_news_headline": "Заголовок новости",
  "static_submit_news_intro": "У вас есть новость? Отправьте ее здесь, и наша редакционная команда рассмотрит ее.",
  "static_submit_news_limit": "Мы принимаем фотографии и видео до",
  "static_submit_news_photos": "Фотографии / Видео (до",
  "static_submit_news_send": "Отправить новость",
  "static_submit_news_sending": "Отправка...",
  "static_submit_news_source": "Источник / Ссылка (по желанию)",
  "static_submit_news_source_placeholder": "URL или ссылка",
  "static_submit_news_thanks": "Спасибо за вашу подачу! Наша команда вскоре рассмотрит это.",
  "static_submit_news_title": "Отправьте свою новость",
  "static_submit_news_your_name": "Ваше имя",
  "status": "Статус",
  "stop": "Остановить",
  "submit": "Отправить",
  "submitNews": "Отправить новости",
  "submit_bug_title": "Сообщить об ошибке",
  "submit_news": "Отправить новость",
  "submit_news_title": "Предложить новость",
  "subscribe": "Подписаться",
  "subscription": "Подписка",
  "subscription_title": "Планы подписки",
  "success": "Успех",
  "support": "Поддержка",
  "tablet": "Планшет",
  "tags": "Теги",
  "target_impressions": "Целевые показы",
  "technology": "Технологии",
  "template": "Шаблон",
  "templates": "Шаблоны",
  "terms": "Условия",
  "thank_you": "Спасибо",
  "this_month": "В этом месяце",
  "this_week": "На этой неделе",
  "this_year": "В этом году",
  "tip": "Совет",
  "title": "Название",
  "to": "До",
  "today": "Сегодня",
  "total": "Всего",
  "translate_all": "Перевести всё",
  "translation_status": "Статус перевода",
  "translations": "Переводы",
  "travel": "Путешествие",
  "trending": "В тренде",
  "try_again": "Повторить",
  "twitter": "Twitter",
  "two_factor_auth": "Двухфакторная аутентификация",
  "type": "Тип",
  "ugc_submit": "Отправить контент",
  "ugc_title": "Портал гражданской журналистики",
  "unique_clicks": "Уникальные клики",
  "unique_opens": "Уникальные открытия",
  "unknown": "Неизвестно",
  "unpublish": "Снять с публикации",
  "unread": "Непрочитано",
  "update": "Обновить",
  "updated_successfully": "Успешно обновлено",
  "upgrade": "Улучшить",
  "upload": "Загрузить",
  "users": "Пользователи",
  "vehicles": "Автотранспорт",
  "verification_code_sent": "Код подтверждения отправлен на вашу электронную почту!",
  "version": "Версия",
  "vibeposao": "Times Posao",
  "view": "Просмотр",
  "view_all": "Посмотреть все",
  "views": "Просмотры",
  "warning": "Предупреждение",
  "welcome": "Добро пожаловать",
  "wish_roles": "Желаемые роли",
  "working_hours_saved": "Рабочие часы сохранены!",
  "world": "Мир",
  "write_new_article": "Написать новую статью",
  "yes": "Да",
  "yesterday": "Вчера",
  "your_bookings": "Ваши бронирования",
  "youtube": "YouTube"
}
